"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CONTENT_EDITABLE = 'contenteditable';
/**
 * Commit information of an entity (type, isReadonly, id) into the wrapper node as CSS Classes
 * @param wrapper The entity wrapper element
 * @param type Entity type
 * @param isReadonly Whether this is a readonly entity
 * @param id Optional Id of the entity
 */
function commitEntity(wrapper, type, isReadonly, id) {
    if (wrapper) {
        wrapper.className = "_Entity" /* ENTITY_INFO_NAME */ + " " + "_EType_" /* ENTITY_TYPE_PREFIX */ + type + " " + (id ? "" + "_EId_" /* ENTITY_ID_PREFIX */ + id + " " : '') + "_EReadonly_" /* ENTITY_READONLY_PREFIX */ + (isReadonly ? '1' : '0');
        if (isReadonly) {
            wrapper.contentEditable = 'false';
        }
        else if (wrapper.getAttribute(CONTENT_EDITABLE)) {
            wrapper.removeAttribute(CONTENT_EDITABLE);
        }
    }
}
exports.default = commitEntity;
//# sourceMappingURL=commitEntity.js.map